import React, { useState, useEffect } from "react";
import "./App.css";
import Login from "./Pages/Login";
import Main from "./Pages/Layout";
import { LogoutOutlined } from "@ant-design/icons";
import { Layout, Button } from "antd";
import { messaging, getToken, onMessage } from "./Pages/firebase";

const { Header, Content } = Layout;

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogout = () => {
    setIsLoggedIn(false);
    console.log("Logged out");
    localStorage.removeItem("userId");
    localStorage.removeItem("role");
  };

  const handleLogin = () => {
    setIsLoggedIn(true);
    console.log("Logged in");
  };

  return (
    <Layout className="layout">
      <Header className="header">
        <div className="logo">Aptope</div>
        {isLoggedIn && (
          <Button danger type="primary" onClick={handleLogout}>
            <LogoutOutlined /> Logout
          </Button>
        )}
      </Header>

      {isLoggedIn ? <Main /> : <Login onLogin={handleLogin} />}
    </Layout>
  );
}

export default App;
